@if(!isFromGlobalDashboard) {
<app-breadcrumbs [headerTitle]="'DASHBOARD'" />
} @if(isFromGlobalDashboard && payGroup && headerCrumbs) {
<app-breadcrumbs
	[headerTitleWithFlag]="headerCrumbs"
	[externalCrumbs]="externalCrumbs"
	[addOverviewTitle]="true"
	[clientSelectedCountry]="clientSelectedCountry"
	[clientCountryList]="clientCountryList!"
/>
} @if(isFromGlobalDashboard && payGroup) {
<app-kpi-cards
	sub-header
	[showLoader]="(this.fetchingDataForFilters | async)!"
	[kpiCardsData]="kpiCards"
	[isClient]="isClient"
></app-kpi-cards>
} @if(payGroup) {
<app-calendar
	sub-header
	(onPayCycleChanges)="handlePayCycleChanged($event)"
	(onNoPayCyclesFound)="payGroupHasNoPayCycles($event)"
	[_payGroup]="payGroup"
></app-calendar>
} @if(tppFundingScreenEnabled) {
<app-download-combined-report
	[payCycle]="payCycle"
	[milestoneGroups]="milestoneGroups"
	[resetForm]="resetDownloadReportForm()"
	(resetDownloadReportDropdownForm)="resetDownloadReportDropdownForm($event)"
/>
}

<div class="payment-main-container">
	@if(!isCalendarMilestonesLoading) { @if(payCycle && milestones.length > 0 && milestoneGroups.length > 0) {
	<div class="event-title" fxLayout="row" fxFlexAlign="space-between center">
		<span>Event details</span>
		<app-legal-entity-timezone-disclaimer
			[isGlobalDashboard]="true"
			[textMessage]="'All times are displayed in your local timezone'"
		></app-legal-entity-timezone-disclaimer>
	</div>
	@if(payCycle && milestones && payGroup) { @for (group of milestoneGroups; track group) {
	<app-event-details-container
		[payGroup]="payGroup"
		[payCycleSelected]="payCycle"
		[milestones]="milestones"
		[group]="group"
		[expandGroupWithName]="expandedMilestoneGroupNameFromHistory"
		[triggerResetPayoutsAsObservable]="triggerResetPayouts$.asObservable()"
		[fundingScreenEnabled]="fundingScreenEnabled"
		[tppFundingScreenEnabled]="tppFundingScreenEnabled"
		(onMilestoneGroupSelected)="setSelectedMilestoneGroupName($event)"
		(onUpdateMilestone)="updateMilestones($event)"
		(onUpdatePayCycle)="updatePayCycle($event)"
	></app-event-details-container>
	} } } @else if(payCycle && !milestones.length) {
	<div class="event-no-item">
		<div class="event-no-item-content">No Milestones have been created for the selected Period.</div>
	</div>
	} @else if(!payCycle) {
	<div class="event-no-item">
		<div class="event-no-item-content">No Pay Cycles have been created for the selected Period.</div>
	</div>
	} }
</div>
@if(showHistoryLogPanel) {
<app-history-log-side-panel [historyType]="HistoryLogType.MILESTONE" />
}
